import { Injectable } from '@angular/core';

type ScormAPI = {
  LMSSetValue: (key: string, value: string) => void;
  LMSFinish: () => string;
  LMSIsInitialized: () => string;
  LMSCommit: () => string;
  LMSInitialize: () => string;
  LMSGetValue: (key: string) => string | undefined;
};
@Injectable({
  providedIn: 'root'
})
export class ScormManagerService {

  public runsInLms() {
    try {
      const windowParentParams = new URLSearchParams(window.parent.location.search);
      if (windowParentParams.get('runsinlms')) {
        return true;
      }
      const windowParentParentParams = new URLSearchParams(window.parent.parent.location.search);
      if (windowParentParentParams.get('runsinlms')) {
        return true;
      }
    } catch (_e: unknown) {
      return false;
    }
    return false;

  }

  private fakeAPI: ScormAPI = {
    LMSSetValue: (key: string, value: string) => {
      this.fakeSCORM[key] = value;
    },
    LMSFinish: () => {
      return "true";
    },
    LMSIsInitialized: () => {
      return "true";
    },
    LMSCommit: () => {
      return "true";
    },
    LMSInitialize: () => {
      return "true";
    },
    LMSGetValue: (key: string) => {
      return this.fakeSCORM[key];
    }
  };

  private fakeSCORM: Record<string, string> = {
    'cmi.suspend_data': "",
    'cmi.core.student_name': "%SCORM_STUDENT_NAME%",
    'cmi.core.student_id': "%SCORM_STUDENT_ID%",
    'cmi.core.score.raw': "",
    'cmi.core.score.min': "",
    'cmi.core.score.max': "",
    'cmi.core.lesson_location': "",
    'cmi.core.lesson_status': "",
    'cmi.interactions._count': ""
  };

  public isFakeScorm() {
    return this.getApiHandle() === this.fakeAPI;
  }

  private getApiHandle() {


    if (this.runsInLms()) {

      const API = (window.parent as { API?: ScormAPI }).API;
      if (API) {
        return API;
      }
    }






    console.warn("Using Dummy Scrom API because no LMS Api found");

    return this.fakeAPI;
  }

  public LMSSetValue(key: string, value: string) {
    this.getApiHandle().LMSSetValue(key, value);
  }

  public LMSFinish() {
    return this.getApiHandle().LMSFinish();
  }

  public LMSIsInitialized() {
    return this.getApiHandle().LMSIsInitialized();
  }

  public LMSCommit() {
    return this.getApiHandle().LMSCommit();
  }

  public LMSInitialize() {
    return this.getApiHandle().LMSInitialize();
  }

  public LMSGetValue(key: string) {
    return this.getApiHandle().LMSGetValue(key);
  }
  //wollen wir den scorm hook noch oder läuft das über events (Die von aussen eh getriggert werden)
  public scormHook(_hook: string, _params: unknown) {
    console.debug("RAGAI.SCORM.LMSHook not used ");
  }







}
